import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { fetchCompany } from '../redux/actions/companyActions';
import { fetchCurrency } from '../redux/actions/settingActions';
import { clearCarts } from '../redux/actions/cartsActions';
import sumBy from "lodash/sumBy"
import isEmpty from "lodash/isEmpty"
import cloneDeep from "lodash/cloneDeep"
import axios from "axios";
import Cookies from 'js-cookie';
import {
  Row,
  Col,
  Container,
} from 'reactstrap';

import Alerts from "../components/Extra/Alerts.js"
import Calculate from "../components/Checkout/Calculate.js";
import ShippingInfo from "../components/Checkout/ShippingInfo.js";
import Infomation from "../components/Checkout/Infomation.js";
import Shipping from "../components/Checkout/Shipping.js";
import Payment from "../components/Checkout/Payment.js";

import client from "../feathers.js"

import PracWorksLogo from '../assets/images/navbarLogo.png'

const Checkout = (props) => {
  const [ formValue, setFormValue ] = useState({})
  const [ activeIndex, setActiveIndex ] = useState(0)
  const [ shippingFee, setShippingFee ] = useState(0)
  const [ shippingFeeMYR, setShippingFeeMYR ] = useState(0)
  const [ spin, setSpin ] = useState(false)
  const [ isOpen, setIsOpen ] = useState(false)
  const [ message, setMessage ] = useState('')
  const [ color, setColor ] = useState('danger')
  const [ upsServices, setUpsServices ] = useState([])
  const [ fedexServices, setFedexServices ] = useState([])
  const [ dhlServices, setDhlServices ] = useState([])
  const [ fedExSpin, setFedExSpin ] = useState(false)
  const [ upsSpin, setUpsSpin ] = useState(false)
  const [ dhlSpin, setDhlSpin ] = useState(false)
  const [ voucherCode, setVoucherCode ] = useState('')
  const [appliedVouchers, setAppliedVouchers] = useState([])
  const [ isApplying, setIsApplying ] = useState(false); // Loading state
  const [ stateCarts, setStateCarts ] = useState([]);

  useEffect(() => {
    if(props?.carts?.length <= 0){
      props.history.push('/products')
    }

    // if (props.currency === "MYR") {
    //   alert("MYR payment is temporarily unavailable. We've switched you to USD currency.");
    //   props.fetchCurrency("USD");
    // }
  }, [props?.carts?.length, props?.history])

  useEffect(() => {

    if (props.carts.some(cart => {
      const missingKeys = [];
      if (cart.oriTotalNetAmount === undefined || cart.oriTotalNetAmount === null) missingKeys.push('oriTotalNetAmount');
      if (cart.oriPerUnitAmount === undefined || cart.oriPerUnitAmount === null) missingKeys.push('oriPerUnitAmount');
      if (cart.discountAmountPerUnit === undefined || cart.discountAmountPerUnit === null) missingKeys.push('discountAmountPerUnit');
      
      if (missingKeys.length > 0) {
        console.log('Cart item missing keys:', missingKeys);
        console.log('Problem cart item:', cart);
        return true;
      }
      return false;
    })) {
      props.clearCarts()
      setTimeout(() => {
        props.history.push('/products')
      }, 500);
    }

    setStateCarts(props.carts || [])
    // eslint-disable-next-line
  }, [props.carts, props.history])
  
  function isCookieExpired(name) {
    var cookieValue = Cookies.get(name);
    if (!cookieValue) {
        return true; // Cookie doesn't exist
    }
    var cookieExpiresAt = Cookies.get('upsToken_expiry');

    // Calculate the time after 14,399 seconds (4 hours)
    var futureDate = new Date(new Date().getTime() + (cookieExpiresAt * 1000)); // Convert seconds to milliseconds
    
    return new Date() > futureDate;
  }

  function getOrSetCookie(){
    var existingCookie = Cookies.get('upsToken');
    if (!existingCookie || isCookieExpired("upsToken")) {
        axios.post(`${client.io.io.uri}ups/v1/get/token`)
        .then(res => {
          if(res?.data?.access_token){
            let expiry_data = res?.data?.expires_in / 86400 // Convert seconds to days
            // Cookie doesn't exist or is expired, set new cookie
            Cookies.set('upsToken', res?.data?.access_token, { expires: expiry_data });
            Cookies.set('upsToken_expiry', res?.data?.expires_in, { expires: expiry_data });
            return res?.data?.access_token;
          }
        })
        .catch(err => console.log(err))
    } else {
        // Cookie exists and is not expired, return old cookie value
        return existingCookie;
    }
  }

  useEffect(() => {
    getOrSetCookie()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const fetchCompanyInfo = async (fetchCompany) => {
      // Fetch company info
      const companyRes = await client.service('companies').find({
        query: {
          $limit: 1,
        }
      })
      
      // Fetch latest exchange rate
      let rateUSDtoMYR = companyRes.data[0]?.rateUSDtoMYR || 4.6
      try {
        const rateRes = await axios.get(`${client.io.io.uri}v2/getExchangeRate`)
        if (rateRes.data?.rateUSDtoMYR) {
          rateUSDtoMYR = rateRes.data.rateUSDtoMYR
        }
      } catch (err) {
        console.log('Failed to fetch exchange rate:', err)
      }
      
      fetchCompany({ ...companyRes.data[0], rateUSDtoMYR })
    }
    fetchCompanyInfo(props.fetchCompany)
  }, [props.fetchCompany])

  const onSubmit = (value) => {
    setSpin(true)
    setFormValue(value)

    let packageCount = sumBy(props.carts, 'quantity')

    let stateOrProvinceCode = (value.stateOrProvinceCode).length >= 2? (value.stateOrProvinceCode).substring(0, 2): value.stateOrProvinceCode

    let params = {
      username: 'EntreShip',
      password: '2bea72d97fd428ac90366f6b2f6118a33f4f2ce15b10eac65ad1081aa589bcf9',
      email: 'sender@customer.com',
      firstName: 'firstName',
      lastName: 'lastName',
      address: value.address,
      country: value.country,
      state: value.state,
      postalCode: value.postalCode,
      phoneNumber: 'phoneNumber',
      countryCode: value.countryCode,
      stateOrProvinceCode: stateOrProvinceCode,
      packageLineItem: [],
      packageCount: packageCount,
      preferredCurrency: props.currency
    }

    let params1 = cloneDeep(params)
    let params2 = cloneDeep(params)
    
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        'Content-Type': 'application/json'
      }
    }
    
    // ignore if ship local
    // sum localShippingAmount from products
    if(value.countryCode === "MY"){
      if(props.carts.length > 0){

        value.serviceCode = ''
        value.shippingCompany = ""
        setFormValue(value)

        // local shipping amount stored in MYR
        const localShippingMYR = Number((sumBy(props.carts, "localShippingAmount") * sumBy(props.carts, "quantity")).toFixed(2))
        // shippingFee is always USD, shippingFeeMYR is always MYR
        setShippingFeeMYR(localShippingMYR)
        setShippingFee(Number((localShippingMYR / props.rateUSDtoMYR).toFixed(2)))
        handleOpen(false, "danger", "")
        setActiveIndex(1)
        setSpin(false)
      }
    }else{
      
      console.log("Original stateOrProvinceCode: " + (value.stateOrProvinceCode))
      console.log("stateOrProvinceCode: " + (stateOrProvinceCode))

      setFedExSpin(true)
      setUpsSpin(true)
      setDhlSpin(true)

        let packageLineItem1 = cloneDeep(props.carts).map((v, i) => {
          return {
            "PackagingType": {
              "Code": "02",
              "Description": "Packaging"
            },
            "PackageWeight": {
              "UnitOfMeasurement": {
                  "Code": "KGS",
                  "Description": "Kilogram"
              },
              "Weight": (v.quantity * v.packageWeight)?.toString()
            },
            "Dimensions": {
              "UnitOfMeasurement": {
                "Code": "CM",
                "Description": "Centimeters"
              },
              "Length": v.packageLength?.toString(),
              "Width": v.packageWidth?.toString(),
              "Height": v.packageHeight?.toString()
            },
            "OversizeIndicator": "X",
            "MinimumBillableWeightIndicator": "X"
          }
        })
        
        let invoice_line_total = {
          monetary_value: 0,
          currency_code: props.currency
        }
        if(props.currency === "USD"){
          invoice_line_total.monetary_value = (sumBy(props.carts, "totalNetAmount")+sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "totalAmount")))).toFixed(2)
        }else{
          invoice_line_total.monetary_value = (sumBy(props.carts, "totalNetAmountMYR")+sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "totalAmountMYR")))).toFixed(2)
        }
        
        params.invoice_line_total = invoice_line_total
        params.packageLineItem = packageLineItem1
        params.token = Cookies.get('upsToken')

        // Ups rating api call
        // axios.post(`${client.io.io.uri}getUpsRates`, params, config)
        axios.post(`${client.io.io.uri}ups/v1/get/rating`, params, config)
        .then(res => {
          
          let RatedShipment = res?.data?.RateResponse?.RatedShipment || []
          
          RatedShipment.map(value => {
            value.shippingCompany = "ups"
            return value
          })
          RatedShipment.map(value => {
            // if(value.Service.Code === "07" || value.Service.Code === "65"){
            //   value.TotalCharges.MonetaryValue = Number(value.TotalCharges.MonetaryValue) * 1.4
            // }

            // after sum
            if(value.Service.Code === "08"){
              // 0.46
              value.TotalCharges.MonetaryValue = Number(value.TotalCharges.MonetaryValue) * 0.46
            }
            // Add 20% markup for UPS
            value.TotalCharges.MonetaryValue = Number(value.TotalCharges.MonetaryValue) * 1.2
            // Store MYR amount
            value.TotalCharges.MonetaryValueMYR = value.TotalCharges.MonetaryValue
            // MonetaryValue is always USD
            value.TotalCharges.MonetaryValue = Number((value.TotalCharges.MonetaryValue / props.rateUSDtoMYR).toFixed(2))
            return value
          })
          
          setUpsServices(RatedShipment)

          setActiveIndex(1)
          handleOpen(false, "danger", "")
          setSpin(false)
          setUpsSpin(false)
        }).catch(err => {
          console.log(err)
          handleOpen(true, "danger", "Something went wrong! or address not available!.")
          setSpin(false)
          setUpsSpin(false)
        });

        let packageLineItem2 = cloneDeep(props.carts).map((v, i) => {
          return {
            SequenceNumber: i + 1,
            groupPackageCount: v.quantity,
            Weight: {
              Units: 'KG',
              Value: v.packageWeight
            },
            Dimensions: {
              Length: v.packageLength || 0,
              Width: v.packageWidth  || 0,
              Height: v.packageHeight || 0,
              Units: 'CM'
            },
            description: v.name || 'General Merchandise',
            countryOfManufacture: 'MY',
            quantity: v.quantity,
            customsValue: v.totalNetAmount || 100,
            declaredValue: v.totalNetAmount || 100
          }
        })

        params1.packageLineItem = packageLineItem2

        axios.post(`${client.io.io.uri}v2/getFedexRates`, params1, config)
        .then(res => {

          // Switch between 'ACCOUNT' (discounted) or 'LIST' (original price)
          const USE_FEDEX_RATE_TYPE = 'ACCOUNT'  // LIST is cheaper with account 204840301
          
          const fedexService = res?.data
            ?.filter(x => x.success && x.data?.output?.rateReplyDetails?.[0]?.ratedShipmentDetails?.[0])
            .map(x => {
              const rateDetail = x.data.output.rateReplyDetails[0]
              const ratedShipmentDetails = rateDetail.ratedShipmentDetails
              
              // Find the rate type we want (ACCOUNT or LIST)
              const shipmentDetail = ratedShipmentDetails.find(r => r.rateType === USE_FEDEX_RATE_TYPE) || ratedShipmentDetails[0]
              const shipmentRateDetail = shipmentDetail.shipmentRateDetail || {}
              const currency = shipmentRateDetail.currency || shipmentDetail.currency
              
              // 
              // const fromCurrency = shipmentRateDetail.currencyExchangeRate.fromCurrency;
              // const intoCurrency = shipmentRateDetail.currencyExchangeRate.intoCurrency;
              // const exchangeRate = shipmentRateDetail.currencyExchangeRate.rate;
              const baseRate = shipmentDetail.totalBaseCharge;
              const fuelSurcharge = shipmentRateDetail?.surCharges?.find(s => s.type === "FUEL")?.amount || 0;
              const usInboundProcessingFee = shipmentRateDetail?.surCharges?.find(s => s.type === "ANCILLARY_FEE")?.amount || 0;
              const volumeDiscount = shipmentRateDetail.totalFreightDiscount;
              var finalAmountMYR = (baseRate + fuelSurcharge + usInboundProcessingFee) - volumeDiscount;
              
              // Add markup for FedEx: 50% for USA, 10% everywhere else
              const fedexMarkup = value.countryCode === "US" ? 1.5 : 1.1
              finalAmountMYR = finalAmountMYR * fedexMarkup
              
              // MonetaryValue is always USD, MonetaryValueMYR is always MYR
              var finalAmount = Number((finalAmountMYR / props.rateUSDtoMYR).toFixed(2))
              
              return {
                ServiceType: x.serviceType,
                Service: {
                  Code: `fedEx-${x.serviceType}`
                },
                TotalCharges: {
                  CurrencyCode: props.currency,
                  MonetaryValue: finalAmount,
                  MonetaryValueMYR: finalAmountMYR
                },
                shippingDiscPercent: 0,
                shippingDiscAmount: 0,
                shippingCompany: "fedex",
                // Original values for debugging
                originalBaseCharge: baseRate,
                originalNetCharge: finalAmount,
                originalCurrency: currency
              }
            }) || []

          setFedexServices(fedexService)

          setActiveIndex(1)
          handleOpen(false, "danger", "")
          setSpin(false)
          setFedExSpin(false)
        }).catch(err => {
          console.log(err)
          handleOpen(true, "danger", "Something went wrong! or address not available!.")
          setSpin(false)
          setFedExSpin(false)
        });


        // DHL rating api call
        let packageLineItem3 = cloneDeep(props.carts).map((v, i) => {
          return {
            weight: v.quantity * v.packageWeight,
            dimensions: {
              length: Number(v.packageLength),
              width: Number(v.packageWidth),
              height: Number(v.packageHeight),
            }
          }
        })
        let monetaryAmount = {
          "typeCode": "declaredValue",
          value: 0,
          currency: props.currency
        }
        if(props.currency === "USD"){
          monetaryAmount.value = Number((sumBy(props.carts, "totalNetAmount")+sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "totalAmount")))).toFixed(2))
        }else{
          monetaryAmount.value = Number((sumBy(props.carts, "totalNetAmountMYR")+sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "totalAmountMYR")))).toFixed(2))
        }
        params2.monetaryAmount = [monetaryAmount]
        params2.packageLineItem = packageLineItem3
        
        axios.post(`${client.io.io.uri}getDHLRates`, params2, config)
        .then(res => {
          // console.log(res)

          res.data.products.map(value => {
            value.shippingCompany = "dhl"
            // MonetaryValue is always USD, MonetaryValueMYR is always MYR
            const originalMYR = Number(value.totalPrice[0]?.price)
            value.TotalCharges = {
              MonetaryValueMYR: originalMYR,
              MonetaryValue: Number((originalMYR / props.rateUSDtoMYR).toFixed(2))
            }
            value.Service = {
              Code: value.productName
            }
            return value
          })
          
          setDhlServices(res.data.products)

          setActiveIndex(1)
          handleOpen(false, "danger", "")
          setSpin(false)
          setDhlSpin(false)
        }).catch(err => {
          console.log(err)
          handleOpen(true, "danger", "Something went wrong! or address not available!.")
          setSpin(false)
          setDhlSpin(false)
        });
        
    }
  }

  const onSubmitShipping = (value) => {
    setActiveIndex(2)
  }

  const onSubmitShippingInfo = (value) => {
    let result = formValue
    result.email = value.email
    result.firstName = value.firstName
    result.lastName = value.lastName
    result.phoneNumber = value.phoneNumber

    setFormValue(result)
    setActiveIndex(3)
  }

  const removeVoucher = (voucherToRemove) => {
    // Filter out the voucher to remove
    const updatedVouchers = appliedVouchers.filter((v) => v.code !== voucherToRemove.code)
    setAppliedVouchers(updatedVouchers)

    // Recalculate cart with remaining vouchers
    recalculateCart(updatedVouchers)
  }

  const recalculateCart = (vouchers) => {
    // Start with original cart values
    let recalculatedCarts = cloneDeep(props.carts)

    // Apply each voucher sequentially
    vouchers.forEach((voucher) => {
      const percentage = voucher?.percentage || 0

      if (voucher.applyTo === "specs") {
        recalculatedCarts = recalculatedCarts.map((cart) => {
          cart.variations = cart.variations.map((variation) => {
            // Find matching variation in the voucher
            const matchedVariation = voucher.variations.find((v) => v.type === variation.type)

            if (matchedVariation) {

              // Apply discount on the variation amount - USD
              const discountAmount = variation.totalAmount * (percentage / 100)
              variation.discountAmount = (variation.discountAmount || 0) + discountAmount
              variation.totalAmount = variation.oriTotalAmount - variation.discountAmount

              const discountAmountPerUnit = variation.amount * (percentage / 100)
              variation.discountAmountPerUnit = (variation.discountAmountPerUnit || 0) + discountAmountPerUnit
              variation.amount = variation.oriAmount - variation.discountAmountPerUnit

              // Apply discount on the variation amount - MYR
              const discountAmountMYR = variation.totalAmountMYR * (percentage / 100)
              variation.discountAmountMYR = (variation.discountAmountMYR || 0) + discountAmountMYR
              variation.totalAmountMYR = variation.oriTotalAmountMYR - variation.discountAmountMYR

              const discountAmountPerUnitMYR = variation.amountMYR * (percentage / 100)
              variation.discountAmountPerUnitMYR = (variation.discountAmountPerUnitMYR || 0) + discountAmountPerUnitMYR
              variation.amountMYR = variation.oriAmountMYR - variation.discountAmountPerUnitMYR
            }

            return variation
          })

          return cart
        })
      } else {
        // Product level discount
        recalculatedCarts = recalculatedCarts.map((cart) => {

          // Calculate cumulative discount - USD
          const discountAmount = cart.totalNetAmount * (percentage / 100)
          cart.discountAmount = (cart.discountAmount || 0) + discountAmount
          cart.totalNetAmount = cart.oriTotalNetAmount - cart.discountAmount

          const discountAmountPerUnit = cart.perUnitAmount * (percentage / 100)
          cart.discountAmountPerUnit = (cart.discountAmountPerUnit || 0) + discountAmountPerUnit
          cart.perUnitAmount = cart.oriPerUnitAmount - cart.discountAmountPerUnit

          // Calculate cumulative discount - MYR
          const discountAmountMYR = cart.totalNetAmountMYR * (percentage / 100)
          cart.discountAmountMYR = (cart.discountAmountMYR || 0) + discountAmountMYR
          cart.totalNetAmountMYR = cart.oriTotalNetAmountMYR - cart.discountAmountMYR

          const discountAmountPerUnitMYR = cart.perUnitAmountMYR * (percentage / 100)
          cart.discountAmountPerUnitMYR = (cart.discountAmountPerUnitMYR || 0) + discountAmountPerUnitMYR
          cart.perUnitAmountMYR = cart.oriPerUnitAmountMYR - cart.discountAmountPerUnitMYR

          return cart
        })
      }
    })

    setStateCarts(recalculatedCarts)
  }

  const applyVoucher = async () => {
    if (!voucherCode) {
      handleOpen(true, "danger", "Please enter a voucher code.")
      return
    }

    if (isApplying) return // Prevent multiple clicks
    setIsApplying(true)

    try {
      // Check if we've already reached the maximum number of vouchers
      if (appliedVouchers.length >= 3) {
        handleOpen(true, "danger", "Maximum of 3 vouchers can be applied.")
        return
      }

      // Check if this voucher is already applied
      if (appliedVouchers.some((v) => v.code === voucherCode)) {
        handleOpen(true, "danger", "This voucher has already been applied.")
        return
      }

      // Fetch voucher details from the database
      const response = await client.service("vouchers").find({
        query: {
          code: voucherCode,
          $limit: 1,
        },
      })

      const vouchers = response.data

      if (vouchers.length === 0) {
        handleOpen(true, "danger", "Invalid voucher code.")
        return
      }

      const voucher = vouchers[0]

      // Validate voucher
      if (!voucher.status) {
        handleOpen(true, "danger", "This voucher code is not available")
        return
      }

      const currentDate = new Date()
      const expiryDate = new Date(voucher.expiryDate)
      if (expiryDate < currentDate) {
        handleOpen(true, "danger", "This voucher has expired.")
        return
      }

      if (voucher.numOfUsage <= 0) {
        handleOpen(true, "danger", "This voucher has reached its usage limit.")
        return
      }

      if (!["product", "specs"].includes(voucher.applyTo)) {
        handleOpen(true, "danger", "This voucher cannot be applied to your cart.")
        return
      }

      // Add the new voucher to our applied vouchers
      const updatedVouchers = [...appliedVouchers, voucher]
      setAppliedVouchers(updatedVouchers)

      // Recalculate cart with all vouchers
      recalculateCart(updatedVouchers)

      // Clear the input field
      setVoucherCode("")

      handleOpen(true, "success", `Voucher "${voucher.code}" applied successfully!`)
    } catch (error) {
      console.error("Error applying voucher:", error)
      handleOpen(true, "danger", "An error occurred while applying the voucher.")
    } finally {
      setIsApplying(false)
    }
  }

  const _RenderActiveIndex = () => {
    if(activeIndex === 1){
      return (
        <Shipping 
          formValue={formValue}
          setActiveIndex={setActiveIndex}
          shippingFee={shippingFee}
          dhlServices={dhlServices}
          upsServices={upsServices}
          fedexServices={fedexServices}
          setShippingFee={setShippingFee}
          setShippingFeeMYR={setShippingFeeMYR}
          setFormValue={setFormValue}
          currency={props.currency}
          rateUSDtoMYR={props.rateUSDtoMYR}
          onSubmitShipping={onSubmitShipping}
          fedExSpin={fedExSpin}
          upsSpin={upsSpin}
          dhlSpin={dhlSpin}
          voucherCode={voucherCode}
          setVoucherCode={setVoucherCode}
          applyVoucher={applyVoucher}
        />
      )
    }else if(activeIndex === 2){
      return (
        <Infomation 
          formValue={formValue}
          setActiveIndex={setActiveIndex}
          userInfo={props.userInfo} 
          onSubmit={onSubmitShippingInfo}
          voucherCode={voucherCode}
          setVoucherCode={setVoucherCode}
          applyVoucher={applyVoucher}
        />
      )
    }else if(activeIndex === 3){
      return (
        <Payment 
          formValue={formValue}
          setActiveIndex={setActiveIndex}
          carts={stateCarts}
          appliedVouchers={appliedVouchers}
          currency={props.currency}
          rateUSDtoMYR={props.rateUSDtoMYR}
          shippingFee={shippingFee}
          shippingFeeMYR={shippingFeeMYR}
          clearCarts={props.clearCarts}
          handleOpen={handleOpen}
          userId={props.userId}
          companyInfo={props.companyInfo}/>
      )
    }else{
      return (
        <ShippingInfo 
          formValue={formValue}
          userInfo={props.userInfo} 
          onSubmit={onSubmit}
          spin={spin}
          voucherCode={voucherCode}
          setVoucherCode={setVoucherCode}
          applyVoucher={applyVoucher}
        />
      )
    }
  }

  const handleOpen = (bool, color, message) => {
    setIsOpen(bool)
    setColor(color)
    setMessage(message)
  }

  return (  
    <>
      {/* <NavBar /> */}
        <main>
          <Row className="w-100 no-gutters">
            <Col md="7" style={{height:'100vh', overflow: 'auto'}}>
              <div style={{padding:'40px 0px'}}>
                <Container className="pl-md-5 pr-md-5">
                  <a href="/" style={{cursor:'pointer'}} className="d-block text-center m-auto pb-3">
                    <img 
                      src={PracWorksLogo} 
                      style={{width: 250}}
                      alt="pracWorks Carbon" 
                    />
                  </a>
                  <Alerts isOpen={isOpen} handleOpen={handleOpen} color={color} message={message} />
                  <h1>Shopping Cart</h1>
                  {_RenderActiveIndex()}
                </Container>
              </div>
            </Col>
            <Col md="5" style={{background:'#F0F2F5', height:'100vh'}}>
              <div style={{padding:'100px 0px'}}>
                <Container className="pl-md-5 pr-md-5">
                  <Calculate 
                    carts={stateCarts}
                    appliedVouchers={appliedVouchers}
                    removeVoucher={removeVoucher}
                    currency={props.currency}
                    rateUSDtoMYR={props.rateUSDtoMYR}
                    shippingFee={shippingFee} 
                    shippingFeeMYR={shippingFeeMYR}
                    countryCode={formValue.countryCode}
                  />
                </Container>
              </div>
            </Col>
          </Row>
        </main>
      {/* <Footer /> */}
   </>
  );
}
 

const mapStateToProps = state => ({
  auth: state.role.auth,
  userId: state.role.details.user?state.role.details.user._id:'',
  userInfo: state.role.details.user?state.role.details.user:{},
  carts: state.carts.data,
  companyInfo: state.company.data,
  rateUSDtoMYR: state.company.data.rateUSDtoMYR?state.company.data.rateUSDtoMYR:4.13,
  currency: state.setting.currency
});

const mapDispatchToProps = {
  fetchCompany: fetchCompany,
  fetchCurrency: fetchCurrency,
  clearCarts: clearCarts
};
export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
